import { TRIGGER_METADATA } from 'modules/workflows/constants';
import { getFilteredTriggerList } from './EventEntrySource.constants';

type Option = { id: string; label: string; value: string; categoryId?: string; Suffix?: string };

/**
 * formatting the trigger options for the UI
 */
export const getEventTypeOptions = (featureFlags: Record<string, boolean> = {}) => {
  const eventTypes = getFilteredTriggerList(featureFlags);
  const events = eventTypes.reduce((acc: Option[], event: string) => {
    const eventData = TRIGGER_METADATA[event];
    return eventData
      ? [
          ...acc,
          {
            id: event,
            // TODO: remove replace label with refreshLabel after StartTileRefresh GA
            label: eventData?.refreshLabel || eventData?.label,
            value: event,
            categoryId: eventData?.categoryId,
            Suffix: eventData?.Suffix,
          },
        ]
      : acc;
  }, []);

  return events;
};
